// extracted by mini-css-extract-plugin
module.exports = {"wave_box":"ParkRoad_wave_box__3_d6t","wave_box_title":"ParkRoad_wave_box_title__3NjfG","wave_item":"ParkRoad_wave_item__XmzYY","wave_item_label":"ParkRoad_wave_item_label__2BC5h"};